function Eraser({ size }: { size: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M16.24 3.56l4.95 4.94a1.5 1.5 0 0 1 0 2.12l-7.07 7.07a1.5 1.5 0 0 1-2.12 0L6.05 11.74a1.5 1.5 0 0 1 0-2.12l7.07-7.07a1.5 1.5 0 0 1 2.12 0zM4.5 20.25h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1 0-1.5zm3.67-9.57l5.66 5.66 6.01-6.01-5.66-5.66-6.01 6.01z"
      />
    </svg>
  )
}

export default Eraser
